var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShadeLeft(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 755,
    height: 1228,
    viewBox: "0 0 755 1228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_1230_43547)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120.993,
    cy: 120.993,
    r: 120.993,
    transform: "matrix(1 1.74846e-07 1.74846e-07 -1 30 647.987)",
    fill: "#FA9EAA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_1230_43547)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120.993,
    cy: 120.993,
    r: 120.993,
    transform: "matrix(1 1.74846e-07 1.74846e-07 -1 107 821.987)",
    fill: "#FFDC99"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1230_43547",
    x: -375.565,
    y: 0.435364,
    width: 1053.12,
    height: 1053.12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 202.782,
    result: "effect1_foregroundBlur_1230_43547"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1230_43547",
    x: -298.565,
    y: 174.435,
    width: 1053.12,
    height: 1053.12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 202.782,
    result: "effect1_foregroundBlur_1230_43547"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadeLeft);
export default __webpack_public_path__ + "static/media/shadeLeft.f3d63a78c5ddd61dce2f857c2a0bad19.svg";
export { ForwardRef as ReactComponent };